module.exports = __webpack_public_path__ + "assets/img/7edab174eccd31f28cd6cf5a2180b19e.png";